// APP DATA
export const LOAD_APP_SETTINGS = 'LOAD_APP_SETTINGS';

export function loadAppSettings(settings) {
  return { type: LOAD_APP_SETTINGS, payload: settings }
}

export const TOAST_SHOW = 'TOAST_SHOW';
export const TOAST_DISMISS = 'TOAST_DISMISS';

export function showToast(message, type, content) {
  return { type: TOAST_SHOW, payload: { message, type, content } }
}

export function dismissToast(id) {
  return { type: TOAST_DISMISS, payload: { id }}
}

export const OPEN_WINDOW = 'OPEN_WINDOW';
export const CLOSE_WINDOW = 'CLOSE_WINDOW';

export function openWindow(windowType, windowProps) {
  return { type: OPEN_WINDOW, payload: { windowType, windowProps } }
}

export function closeWindow() {
  return { type: CLOSE_WINDOW }
}

export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';

export function showModal(modalType, modalProps, modalContentProps) {
  return { type: MODAL_SHOW, payload: { modalType, modalProps, modalContentProps } }
}

export function hideModal() {
  return { type: MODAL_HIDE }
}

export const INITIATE_DOWNLOAD = 'INITIATE_DOWNLOAD';

export function initiateDownload(data) {
  return { type: INITIATE_DOWNLOAD, payload: { ...data } }
}

export const RESET_DOWNLOAD = 'RESET_DOWNLOAD';

export function resetDownload() {
  return { type: RESET_DOWNLOAD }
}

// APP DATA
export const LOAD_USER_DATA = 'LOAD_USER_DATA';

export function loadUserData(userData) {
  return { type: LOAD_USER_DATA, payload: userData }
}

// PORTAL
export const LOAD_PORTAL = 'LOAD_PORTAL';

export function loadPortal(portalComponents) {
  return { type: LOAD_PORTAL, payload: portalComponents }
}

// ContextMenu
export const CONTEXT_MENU_SHOW = 'CONTEXT_MENU_SHOW';
export const CONTEXT_MENU_HIDE = 'CONTEXT_MENU_HIDE';

export function showContextMenu(menuProps) {
  return { type: CONTEXT_MENU_SHOW, payload: menuProps }
}

export function hideContextMenu() {
  return { type: CONTEXT_MENU_HIDE }
}

// ContextMenu
export const POPOVER_SHOW = 'POPOVER_SHOW';
export const POPOVER_HIDE = 'POPOVER_HIDE';

export function showPopover(menuProps) {
  return { type: POPOVER_SHOW, payload: menuProps }
}

export function hidePopover() {
  return { type: POPOVER_HIDE }
}